export const SET_INSTRUCTOR_DATA = 'SET_INSTRUCTOR_DATA';
export const INSTRUCTOR_DATA_ERROR = 'INSTRUCTOR_DATA_ERROR';
export const INSTRUCTOR_DATA_SUCCESS = 'INSTRUCTOR_DATA_SUCCESS';
export const INSTRUCTOR_DATA_LOADING = 'INSTRUCTOR_DATA_LOADING';
